import MoreButton from './MoreButton';
import MoreButtonCoreBadges from './MoreButton.core_badges';
import { withFeatureBranch } from '../../../redux/flags';
export default withFeatureBranch({
    core_badges: MoreButtonCoreBadges,
})(MoreButton);
//# sourceMappingURL=index.js.map